import React, { Component } from 'react'
import Icon from 'react-icons-kit'
import { ic_phone as mdIc_phone } from 'react-icons-kit/md/ic_phone'
import { ic_mail as mdIc_mail } from 'react-icons-kit/md/ic_mail'
import { ic_place as mdIc_place } from 'react-icons-kit/md/ic_place'
import { facebookSquare as faFacebookSquare } from 'react-icons-kit/fa/facebookSquare'
import BreakPoint from '../../responsive-utilities/breakpoint'
import AspectRatio from '../AspectRatio'
import iconWaze from '../../assets/img/waze.png'
import trustedMalaysia from '../../assets/img/trustedmalaysia.png'
import logoWhite from '../../assets/img/logo-white.png'
import jata from '../../assets/img/jata.png'
import './style.css'

const styles = {
  footer: {
    //padding: '0 .5rem',
  },
}

class Footer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isMapFocused: false,
    }

    this.onMapTouchTap = this.onMapTouchTap.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
  }

  onMapTouchTap() {
    if (!this.state.isMapFocused) {
      this.setState({ isMapFocused: true })
    }
  }

  onMouseLeave() {
    if (this.state.isMapFocused) {
      this.setState({ isMapFocused: false })
    }
  }

  render() {
    const { data } = this.props
    const iframeStyle = {
      border: 0,
      pointerEvents: this.state.isMapFocused ? 'auto' : 'none',
    }

    const googleMapsClassName = `google-maps${this.state.isMapFocused ? ' active' : ''}`

    const isProductPage = window.location.href.indexOf('/products/') !== -1

    return (
      <div className="footer" style={styles.footer}>
        <div className="container">
          <div className="content">
            {false &&
              <div className="columns">
                <div className="wrapper">
                  <div className={googleMapsClassName} onClick={this.onMapTouchTap} onMouseLeave={this.onMouseLeave}>
                    <BreakPoint query="smUp">
                      {(matches) => {
                        if (matches) {
                          return (
                            <AspectRatio aspectRatio={16 / 9}>
                              <iframe src={data.googleMapsEmbed}
                                frameBorder="0"
                                style={iframeStyle}
                                allowFullScreen
                                title="Google Maps"
                              ></iframe>
                              <div className="overlay">View Map</div>
                            </AspectRatio>
                          )
                        } else {
                          return (
                            <AspectRatio aspectRatio={4 / 3}>
                              <iframe src={data.googleMapsEmbed}
                                frameBorder="0"
                                style={iframeStyle}
                                allowFullScreen
                                title="Google Maps"
                              ></iframe>
                              <div className="overlay">View Map</div>
                            </AspectRatio>
                          )
                        }
                      }}
                    </BreakPoint>
                  </div>
                </div>
              </div>
            }
            <div className="columns">
              <div className="wrapper">
                <div className="contact">
                  <img src={logoWhite} alt={data.name} className="logo" />

                  <div className="address" style={{ margin: '1rem 0' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <div style={{ paddingRight: '.5rem' }}>
                        <Icon icon={mdIc_place} className="contact-icon" />
                      </div>
                      <div>
                        <a href={data.googleMapsLink} target="_blank" rel="noopener noreferrer">
                          {false && data.address.split('\n').map((item, index) => {
                            return (index === 0) ? item : [<br />, item]
                          })}
                          {data.address}
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="phone" style={{ margin: '1rem 0' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <div style={{ paddingRight: '.5rem' }}>
                        <Icon icon={mdIc_phone} className="contact-icon" />
                      </div>
                      <div>
                        {
                          data.phone.map((phone, index) => {
                            return (
                              <div style={{ margin: 0, marginBottom: index === 0 ? '.5rem' : '.5rem' }} key={index}>
                                <a href={`tel:${phone.number.replace(/[\s-]/g, '')}`}>{phone.number}</a>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>

                  <div className="email" style={{ margin: '1rem 0' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <div style={{ paddingRight: '.5rem' }}>
                        <Icon icon={mdIc_mail} className="contact-icon" />
                      </div>
                      <div>
                        <a href={`mailto:${data.email}`}>{data.email}</a>
                      </div>
                    </div>
                  </div>

                  {!!data.facebook && !!data.facebook.pageLink && !!data.facebook.pageLinkName &&
                    <div className="facebook" style={{ margin: '1rem 0' }}>
                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div style={{ paddingRight: '.5rem' }}>
                          <Icon className="facebook-icon" icon={faFacebookSquare} />
                        </div>
                        <div>
                          <a href={data.facebook.pageLink} title="Facebook" target="_blank" rel="noopener noreferrer">
                            {data.facebook.pageLinkName}
                          </a>
                        </div>
                      </div>
                    </div>
                  }

                  {false &&
                    <div className="icons">
                      <a href={data.wazeLink}>
                        <img src={iconWaze} alt="Open with Waze" />
                      </a>
                    </div>
                  }

                  {isProductPage ? (
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '-2rem' }}>
                      <a href="https://www.trustedmalaysia.com/best-dermatologist-malaysia/#6_AY_Skin_Specialist_Clinic"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        title="TrustedMalaysia.com"
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <img src={trustedMalaysia} alt="Trusted Malaysia"
                          style={{ width: 64 }}
                        />
                        <span style={{ paddingLeft: 4, fontWeight: 'bold' }}>TrustedMalaysia.com</span>
                      </a>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="container">
            <div className="content"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {data.name} &copy; {(new Date()).getFullYear()} All Rights Reserved
              {!isProductPage && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img src={jata} style={{ height: 24, margin: '0 8px' }} alt="KKLIU" />
                  <span>KKLIU 2094/2019</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/index.js